import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { injectDispatch } from '@ngrx/signals/events';
import { InputNumberModule } from 'primeng/inputnumber';
import { CalendarInputComponent } from '@navstation-portal/shared/ui/components';
import {
  AbstractStoreConnectedSectionComponent,
  offshoreBunkerFormEvents,
  OffshoreBunkerFormStore,
} from '@navstation-portal/reporting/data-access/offshore-report';

@Component({
  selector: 're-fuel-oil-bunkers',
  templateUrl: './fuel-oil-bunkers.component.html',
  styleUrl: './fuel-oil-bunkers.component.css',
  imports: [FormsModule, InputNumberModule, CalendarInputComponent],
})
export class FuelOilBunkersComponent extends AbstractStoreConnectedSectionComponent {
  tabId = 'bunker';
  sectionId = 'fuelOilBunkers';
  events = injectDispatch(offshoreBunkerFormEvents);
  bunkerStore = inject(OffshoreBunkerFormStore);
}
